import React from 'react'
import './Donation_card.css'
import { Link } from "react-router-dom";
import Orange_Btn from '../../common_btn/orange_btn/Orange_Btn';
import { IDS } from '../../../../utils/IDS';
import { encodeId } from '../../../../utils/common';

const Donation_card = ({ item }) => {
    return (
        <>
            <section className='Donation_card_sec'>
                <div className='row'>
                    <div className='col-3 pe-0'>
                        <div className='imgdiv'>
                            <img src={`${IDS.IMG_URL}${item?.image}`} className="image" />
                        </div>
                    </div>
                    <div className='col-9 ps-0'>
                        <div className='cont_div'>
                            <div className='row'>
                                <div className='col-md-8 mb-2'>
                                    <h3 className='headtitle'>{item?.name}</h3>
                                    <p className='crdcont'>{item?.subname}</p>
                                </div>
                                <div className='col-md-4'>
                                    <Link to={`/annadanam/${encodeId(item?.id)}`}><Orange_Btn btnText={'Donate'} className="zoom_in_out" /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Donation_card